import { intl } from '@helpers/intl';

/**
 * @typedef {Object} Transaction
 * @property {string} goodsServices - transaction type name
 * @property {string} vatRateName - transaction type name
 */

/**
 * Builds the transaction type name accordingly
 * @param {string} vgTransactionTypeName - transaction type name
 * @param {Transaction} [vgTransactionType] - transaction type
 * @returns {string|*}
 */
export const getTransactionType = (vgTransactionTypeName, vgTransactionType) => {
  if (vgTransactionType) {
    if (vgTransactionType?.vatRateName) {
      return `${vgTransactionTypeName}-${vgTransactionType?.goodsServices}-${vgTransactionType.vatRateName}`;
    }

    return `${vgTransactionTypeName}-${vgTransactionType?.goodsServices}`;
  }

  if (vgTransactionTypeName) {
    return vgTransactionTypeName;
  }

  return intl.formatMessage({
    id: 'components.summary-table.transaction.blank-type',
    defaultMessage: 'Undefined',
  });
};
